import { mediaBreakpointDown, mediaBreakpointUp, mergeWithComponentCustomizedStyles, sizes } from 'conversional-theme';
import { generateClasses } from 'conversional-components';
var Styles = function (theme) {
    var _a, _b;
    var staticStyles = {
        window: {
            backgroundColor: theme.colors.surface_light,
            height: '100%',
        },
        modal: (_a = {
                height: '100%',
                minHeight: '100%',
                margin: 'auto',
                padding: 15,
                maxWidth: '1240px',
                position: 'relative'
            },
            _a[mediaBreakpointDown(sizes.xs)] = {
                padding: 10,
            },
            _a),
        closeButtonContainer: (_b = {
                alignItems: 'center',
                cursor: 'pointer',
                display: 'flex',
                height: 24,
                position: 'absolute',
                right: 10,
                zIndex: 2,
                gap: 10,
                ':hover': {
                    transition: "all .3s ease-out stroke:".concat(theme.colors.brand),
                }
            },
            _b[mediaBreakpointUp(sizes.md)] = {
                height: 60,
                right: 0,
            },
            _b['@media print'] = {
                display: 'none',
            },
            _b),
        PosedModal: {
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            transition: '200ms',
        },
    };
    return mergeWithComponentCustomizedStyles(theme, "modalComponent", staticStyles);
};
export var getStyles = function (theme) { return generateClasses(function () { return Styles(theme); })(); };
